import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import Auth from '../components/Auth';
import Nav from '../components/Nav';
import axios from 'axios';
import '../css/Gestion.css';

function Gestion() {
    const [pedidos, setPedidos] = useState([]);
    const [CursosPublicados, setCursosPublicados] = useState([]);
    const [searchTerm, setSearchTerm] = useState('');

    useEffect(() => {
        const fetchData = async () => {
          try {
            // Obtener cursos publicados
            const responseCursos = await axios.get(
              `${process.env.REACT_APP_BACKEND_URL}/curso/buscar`
            );
            const idsPublicados = responseCursos.data.map(curso => curso.wp_id || curso);
            setCursosPublicados(idsPublicados);
      
            // Descargar cursos
            const idsString = idsPublicados.join(',');
            const responsePedidos = await axios.get(
              `${process.env.REACT_APP_BACKEND_URL}/pedidowp/buscar/${idsString}`
            );

            console.log('Pedidos Descargados:', responsePedidos.data);
            
            // Agrupar pedidos por curso
            const pedidosAgrupados = responsePedidos.data.reduce((acc, pedido) => {
              const nombreCurso = pedido.nombre_producto;
              if (!acc[nombreCurso]) {
                acc[nombreCurso] = {
                  curso: nombreCurso,
                  idCurso: pedido.numero_producto,
                  pedidos: [pedido],
                };
              } else {
                acc[nombreCurso].pedidos.push(pedido);
              }
              return acc;
            }, {});
      
            // Convertir el objeto a una lista
            const listaPedidosAgrupados = Object.values(pedidosAgrupados);
      
            setPedidos(listaPedidosAgrupados);
          } catch (error) {
            console.error('Error en useEffect:', error);
          }
        };
      
        fetchData();
      }, []);

    const handleSearchChange = (e) => {
        setSearchTerm(e.target.value);
    };

    const filteredPedidos = pedidos.filter(curso =>
        curso.curso.toLowerCase().includes(searchTerm.toLowerCase())
    );

    return (
        <Auth>
            {({ nombreUsuario, isAdmin}) => (
                <div>
                    <Nav />
                    <div className='gestion_container'>
                        <h3 className='gestion-h3'>Bienvenido {nombreUsuario}</h3>

                        <h1 className='gestion-h1'>Pedidos de Cursos con Documentación Asignada</h1>
                        <h2 className='gestion-h2'>Cursos</h2>
                        <input  className='gestion-imputbuscar'
                            type="text"
                            placeholder="Buscar por curso..."
                            value={searchTerm}
                            onChange={handleSearchChange}
                        />
                        <ul>
                            {filteredPedidos.map((curso, index) => (
                                <li  className='gestion-li' key={index}>
                                    <div className='curso_info'>
                                        <div>
                                            <b>Nombre del curso:</b><br/> 
                                            {curso.curso}
                                        </div>
                                        <div>
                                            <b>Id curso: </b>{curso.idCurso}
                                        </div>
                                        <div className='pedido_info'>
                                            <b>Número de pedidos: {curso.pedidos.length}</b>
                                            <Link
                                                to={`/revisar/${curso.idCurso}`}
                                                state={{ pedidos: curso.pedidos }}
                                            >
                                                <button  className='gestion-botonrebisar'>Revisar</button>
                                            </Link>
                                        </div>
                                    </div>
                                </li>
                            ))}
                        </ul>
                    </div>
                </div>
            )}
        </Auth>
    );
}

export default Gestion;
